const U = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600`;

export const RIVIERA_HERO = U("photo-1554149082-75d460afced3");
export const VILLA_INTERIOR = U("photo-1512918728675-ed5a9ecdebfd");
export const NL_IMAGE = U("photo-1583295125721-766a0088cd3f");

export const RIVIERA_CITIES = [
  { slug: "nice", name: "Nice", image: U("photo-1643914729809-4aa59fdc4c17") },
  { slug: "cannes", name: "Cannes", image: U("photo-1630312667869-fe3d55bbcc87") },
  { slug: "antibes", name: "Antibes", image: U("photo-1599986518926-e1b54d26b5cb") },
  { slug: "saint-tropez", name: "Saint-Tropez", image: U("photo-1663219943556-c58791315de8") },
  { slug: "monaco", name: "Monaco", image: U("photo-1594161673326-7f91671d8e3b"), inquiryOnly: true },
];

export const findCity = (slug) => RIVIERA_CITIES.find((c) => c.slug === slug);

// value = stored service_type (English, consistent with NL admin data)
export const RIVIERA_SERVICES = [
  { key: "regular", value: "Regular Cleaning" },
  { key: "deep", value: "Deep Cleaning" },
  { key: "move", value: "Move-In / Move-Out Cleaning" },
  { key: "post", value: "Post-Construction Cleaning" },
  { key: "office", value: "Office / Commercial Cleaning" },
  { key: "airbnb", value: "Airbnb Cleaning" },
  { key: "window", value: "Window Cleaning" },
  { key: "garden", value: "Garden / Terrace Cleaning" },
  { key: "pressure", value: "Pressure Washing" },
  { key: "villa", value: "Villa / Yacht-Season Turnover" },
];

export const RIVIERA_FREQUENCIES = [
  { value: "one-time", labelKey: "book_v2.frequency.one_time" },
  { value: "weekly", labelKey: "book_v2.frequency.weekly" },
  { value: "bi-weekly", labelKey: "book_v2.frequency.bi_weekly" },
  { value: "monthly", labelKey: "book_v2.frequency.monthly" },
  { value: "seasonal", labelKey: "riviera.inquiry.freq_seasonal" },
];

export const NL_AREAS = [
  { city: "Amsterdam", neighborhoods: "Centrum, Oud-Zuid, De Pijp, Jordaan, Oost, West", image: U("photo-1534351590666-13e3e96b5017") },
  { city: "Rotterdam", neighborhoods: "Centrum, Kralingen, Hillegersberg, Delfshaven", image: U("photo-1614521272693-73052eaefc51") },
  { city: "Utrecht", neighborhoods: "Binnenstad, Oost, Wittevrouwen, Lombok", image: U("photo-1766668694474-72e9e9022346") },
  { city: "The Hague", neighborhoods: "Centrum, Scheveningen, Bezuidenhout, Statenkwartier", image: U("photo-1719732882413-167d9c493a93") },
  { city: "Eindhoven", neighborhoods: "Centrum, Strijp, Stratum, Woensel", image: U("photo-1707001472448-e26a0f4494e7") },
  { city: "Haarlem", neighborhoods: "Centrum, Schalkwijk, Oost, Noord", image: U("photo-1767689641209-a2ad9e225f08") },
  { city: "Delft", neighborhoods: "Binnenstad, Tanthof, Voorhof", image: U("photo-1664809974948-8c75c66477f5") },
  { city: "Amersfoort", neighborhoods: "Centrum, Vathorst, Hoogland", image: U("photo-1719603785504-4b934e10681d") },
  { city: "Alphen aan den Rijn", neighborhoods: "Centrum, Ridderveld, Kerk en Zanen, Oudshoorn, Hoorn", image: U("photo-1782156451636-c3428e4824cd") },
].map((a) => ({ ...a, slug: a.city.toLowerCase().replace(/\s+/g, "-") }));

// Monaco is inquiry-only → its pill/card goes straight to the inquiry form
export const rivieraCityLink = (c) => (c.inquiryOnly ? `/fr/inquiry?city=${c.slug}` : `/fr/${c.slug}`);

export const findNlArea = (slug) => NL_AREAS.find((a) => a.slug === slug);
